'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

/**
 * mh. wordmark — 4 states:
 *   - default        (other routes: navigate to Hub)
 *   - current        (on Hub: no-op, no background)
 *   - hub            (espresso color, no bg at rest)
 *   - do             (always-visible pill, looks like a button — in Launch Pad)
 */
export function Wordmark() {
  const pathname = usePathname() ?? '/';
  const onHub = pathname === '/';

  const classes = onHub ? 'gh-wordmark hub current' : 'gh-wordmark do';
  const ariaLabel = onHub ? 'Home · current page' : 'Home';

  if (onHub) {
    return (
      <button type="button" className={classes} aria-label={ariaLabel} aria-current="page">
        mh.
      </button>
    );
  }

  return (
    <Link href="/" className={classes} aria-label={ariaLabel}>
      mh.
    </Link>
  );
}
